import React from 'react';
import PropTypes from 'prop-types';
import blankFlag from '@hydra/assets/flags/blank.gif';

export class Flag extends React.PureComponent {
  static propTypes = {
    country: PropTypes.string.isRequired
  }

  static defaultProps = {
    country: 'int'
  };

  render () {
    const { country } = this.props;

    return (
      <img
        src={blankFlag}
        className={`flag flag-${country}`}
        alt={`Flag of ${country}`}
      />
    );
  }
}

export default Flag;
